//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userNoticeSubscribeApi, userNoticeSubscribeShowApi } from '@/api/user';
export default {
  name: 'subscribe',
  components: {
    formBox: function formBox() {
      return import('./components/formBox');
    }
  },
  data: function data() {
    return {
      tableData: [],
      messageData: {},
      where: {
        page: 1,
        limit: 15,
        cate_id: '',
        title: ''
      },
      total: 0,
      loadBtn: false,
      loading: false,
      type: [0, 1]
    };
  },
  mounted: function mounted() {
    this.$store.commit('app/SET_PARENTCUR', 101);
    this.getTableData();
  },
  methods: {
    // 获取列表
    getTableData: function getTableData() {
      var _this = this;
      userNoticeSubscribeApi(this.where).then(function (res) {
        _this.tableData = res.data.list;
        _this.total = res.data.count;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    confirmData: function confirmData(data) {
      this.where.page = 1;
      this.where.title = data.name;
      this.where.cate_id = data.types;
      this.getTableData();
    },
    //修改状态
    messageSubscribe: function messageSubscribe(row) {
      var _this2 = this;
      userNoticeSubscribeShowApi(row.id, {
        status: row.is_subscribe
      }).then(function (res) {
        _this2.getTableData();
      }).catch(function (error) {
        row.row.user_sub = !row.is_subscribe;
      });
    }
  }
};